module.exports = __webpack_public_path__ + "img/grow2.224f8437.png";